import {Exclude, Expose, instanceToPlain, plainToInstance} from "class-transformer";
import * as t from "io-ts";
import {validateJSON, validateJSONNow} from "../web/validation";
import {Entity} from "./entity";

export const OilGoPreferenceCodec = t.intersection([
  t.type({
    id: t.string,
    objectId: t.string,
    objectType: t.string,
  }),
  t.partial({
    gaugeAutoCalcEnabled: t.boolean,
    prePostTripEnabled: t.boolean,
    prepopulatePickupQuantity: t.boolean,
    shiftAuthorizationEnabled: t.boolean,
    showUserActivityOnly: t.boolean,
    createDttm: t.number,
    lastModifiedDttm: t.number,
  }),
]);

export const OilGoPreferenceArrayCodec = t.array(
  OilGoPreferenceCodec
);

export type OilGoPreference = t.TypeOf<typeof OilGoPreferenceCodec>;
export type OilGoPreferenceArray = t.TypeOf<typeof OilGoPreferenceArrayCodec>;

@Exclude()
export class OilGoPreferenceEntity implements Entity {
  @Expose()
  id!: string;

  @Expose()
  objectId!: string;

  @Expose()
  objectType!: string;

  @Expose()
  gaugeAutoCalcEnabled?: boolean;

  @Expose()
  prePostTripEnabled?: boolean;

  @Expose()
  prepopulatePickupQuantity?: boolean;

  @Expose()
  shiftAuthorizationEnabled?: boolean;

  @Expose()
  showUserActivityOnly?: boolean;

  @Expose()
  createDttm?: number;

  @Expose()
  lastModifiedDttm?: number;

  readonly entityType = 'OILGO_PREF';

  get displayName(): Readonly<string> {
    return this.id;
  }

  /**
   * Constructor for OilGoPreferenceEntity. Recommend using the {@link create} method instead.
   * @hideconstructor
   */
  constructor() {
    // Empty constructor for 'class-transformer'
  }

  static from(value: OilGoPreference): OilGoPreferenceEntity {
    return plainToInstance(OilGoPreferenceEntity, value, {
      excludeExtraneousValues: true,
    });
  }

  loadTypeValue(): Promise<OilGoPreference> {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSON(OilGoPreferenceCodec, object);
  }

  asTypeValue(): OilGoPreference {
    const object = instanceToPlain(this, {
      excludeExtraneousValues: true,
    });
    return validateJSONNow(OilGoPreferenceCodec, object);
  }
}
